
<template>
    <tfoot class="tfoot-p1">
        <tr>
            <td scope="col" class="d-none">
                <span class="custom-control custom-checkbox">
                    <input id="theadcheck" type="checkbox" class="custom-control-input">
                    <label for="theadcheck" class="custom-control-label ml-2"></label>
                </span>
            </td>
            <td scope="col" class="d-none">
                <button class="modal__buttons__item w-auto px-2 ml-0 mt-3">Auto #</button>
            </td>
            <td style="position: relative;" scope="col" v-html="'Total Rooms Minutes:'"/>
            <td scope="col" v-html="'TM'" colspan="4"/>
            <td scope="col" v-for="(item, i) in minutes_results" :key="i" v-html="item.total"/>
            <td scope="col" colspan="8"/>
        </tr>
        <tr>
            <td scope="col" class="d-none">
                <span class="custom-control custom-checkbox">
                    <input id="theadcheck" type="checkbox" class="custom-control-input">
                    <label for="theadcheck" class="custom-control-label ml-2"></label>
                </span>
            </td>
            <td scope="col" class="d-none">
                <button class="modal__buttons__item w-auto px-2 ml-0 mt-3">Auto #</button>
            </td>
            <td style="position: relative;" scope="col" v-html="'Total Productivity Minutes:'"/>
            <td scope="col" colspan="4"/>
            <td scope="col" v-html="current_day_number == 0 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 1 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 2 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 3 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 4 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 5 ? summed_daily_minutes : ''"/>
            <td scope="col" v-html="current_day_number == 6 ? summed_daily_minutes : ''"/>
            <td scope="col" colspan="3"/>
        </tr>
        <tr v-if="all_total_minutes">
            <td scope="col" class="d-none">
                <span class="custom-control custom-checkbox">
                    <input id="theadcheck" type="checkbox" class="custom-control-input">
                    <label for="theadcheck" class="custom-control-label ml-2"></label>
                </span>
            </td>
            <td scope="col" class="d-none">
                <button class="modal__buttons__item w-auto px-2 ml-0 mt-3">Auto #</button>
            </td>
            <td style="position: relative;" scope="col" v-html="'Total Minutes:'"/>
            <td scope="col" colspan="4"/>
            <td scope="col" v-html="current_day_number == 0 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 1 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 2 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 3 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 4 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 5 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" v-html="current_day_number == 6 ? all_total_minutes.toFixed(1) : ''"/>
            <td scope="col" colspan="3"/>

        </tr>
        <tr>
            <td scope="col" class="d-none">
                <span class="custom-control custom-checkbox">
                    <input id="theadcheck" type="checkbox" class="custom-control-input">
                    <label for="theadcheck" class="custom-control-label ml-2"></label>
                </span>
            </td>
            <td scope="col" class="d-none">
                <button class="modal__buttons__item w-auto px-2 ml-0 mt-3">Auto #</button>
            </td>
            <td scope="col" v-html="'Total SQ FT:'"/>
            <td scope="col" colspan="4"/>
            <td scope="col" v-for="(item, i) in square_results" :key="i" v-html="item.total"/>
            <td scope="col" colspan="1"/>
        </tr>
    </tfoot>
</template>

<script>

    export default {

        name:   'AssignmentRoomResults',

        props:[
            'current_day_number',
            'minutes_results',
            'square_results',
            'summed_daily_minutes',
            'all_total_minutes'
        ],

    }

</script>